import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { Button } from '..';
import './style.css';

// Fix for default marker icon
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

function LocationMarker({ position, setPosition }) {
  const map = useMap();

  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
  });

  useEffect(() => {
      if (position) {
          map.flyTo(position, map.getZoom());
      }
  }, [position, map]);

  return position === null ? null : (
    <Marker position={position}></Marker>
  );
}

export default function LocationPicker({ initialLatitude, initialLongitude, onConfirm, onCancel }) {
  const [position, setPosition] = useState(() => {
    if (initialLatitude && initialLongitude) {
        const lat = parseFloat(initialLatitude);
        const lng = parseFloat(initialLongitude);
        if (!isNaN(lat) && !isNaN(lng)) {
            return { lat, lng };
        }
    }
    return null;
  });

  useEffect(() => {
    if (initialLatitude && initialLongitude) {
        const lat = parseFloat(initialLatitude);
        const lng = parseFloat(initialLongitude);
        if (!isNaN(lat) && !isNaN(lng)) {
            setPosition({ lat, lng });
        }
    } else {
      // Se não houver localização inicial, tenta pegar a localização do usuário
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            setPosition({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude
            });
          },
          (error) => {
            console.warn("Erro ao obter geolocalização:", error);
          },
          { enableHighAccuracy: true }
        );
      }
    }
  }, [initialLatitude, initialLongitude]);

  const defaultCenter = position || { lat: -23.550520, lng: -46.633308 }; // Default to São Paulo

  const handleConfirm = () => {
    if (position) {
      onConfirm(position.lat, position.lng);
    } else {
        // Maybe allow clearing? Or just close.
        onCancel();
    }
  };

  return (
    <div className="location-picker-container">
      <div className="map-wrapper">
        <MapContainer center={defaultCenter} zoom={13} scrollWheelZoom={true} style={{ height: '400px', width: '100%' }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <LocationMarker position={position} setPosition={setPosition} />
        </MapContainer>
      </div>
      <div className="picker-actions">
          <p className="help-text">Clique no mapa para selecionar a localização exata.</p>
          <div className="buttons">
            <Button onClick={onCancel} variant="ghost" type="button">Cancelar</Button>
            <Button onClick={handleConfirm} type="button">Confirmar Localização</Button>
          </div>
      </div>
    </div>
  );
}
